import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroTallComponent } from './hero-tall.component';
import { ButtonModule } from '../../button';
import { BreadcrumbModule } from '../../breadcrumb';
import { MarkdownModule, MarkdownService, SECURITY_CONTEXT } from 'ngx-markdown';
import { HeroModule } from '../hero.module';
import { HeroBgVideoComponent } from './hero-bg-video/hero-bg-video.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    BreadcrumbModule,
    HeroModule,
    {
      ngModule: MarkdownModule,
      providers: [
        MarkdownService,
        {
          provide: SECURITY_CONTEXT,
          useValue: SecurityContext.HTML,
        },
      ],
    },
  ],
  declarations: [HeroTallComponent, HeroBgVideoComponent],
  exports: [HeroTallComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeroTallModule {
  public static forRoot(environment: any): ModuleWithProviders<HeroTallModule> {
    return {
      ngModule: HeroTallModule,
      providers: [
        {
          provide: 'env',
          useValue: environment,
        },
      ],
    };
  }
}
